import React from 'react';

export default function DashboardCard({ icon, label, value, trend }) {
  return (
    <div className="dash-card">
      <div className="dash-card-icon">{icon}</div>
      <div className="dash-card-label">{label}</div>
      <div className="dash-card-value">{value}</div>
      {trend && <div className="dash-card-trend">{trend}</div>}
    </div>
  );
}
